import React from "react";
import { OperationCompletedPanel } from "../layout/OperationCompletedPanel";
import { formatMessage } from "../../utils/helpers/LanguageHelper";

export const UnauthorizedError = () => {
  return (
    <OperationCompletedPanel
      message={formatMessage("cof.access.message.error.usernotauthorized")}
      alt={formatMessage("cof.access.message.error.usernotauthorized")}
      icon="/assets/Unauthorized.svg"
      styles={{ container: { minHeight: "70vh" } }}
    />
  );
};
